import React, { useEffect, useRef, useState } from 'react';
import { animate, useInView } from 'framer-motion';
import { Reveal } from '../Reveal';
import { facts } from '../../data/site';
export function StatsIntro() {
  const ref = useRef<HTMLSpanElement>(null);
  const inView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  const [count, setCount] = useState(0);
  useEffect(() => {
    if (!inView) return;
    const controls = animate(0, 200, {
      duration: 1.1,
      ease: [0.23, 1, 0.32, 1],
      onUpdate: v => setCount(Math.round(v))
    });
    return () => controls.stop();
  }, [inView]);
  return <section id="intro" className="bg-ink py-24 md:py-36" data-id="element-152" data-mp="2p62liefj9rdj">
      <div className="mx-auto grid max-w-7xl gap-14 px-5 md:px-8 lg:grid-cols-[1.2fr_1fr] lg:items-end" data-id="element-153" data-mp="2p7ng241ulabe">
        <div data-id="element-154" data-mp="ndxvj8hlh45g">
          <p className="text-sm font-medium text-paper/60" data-id="element-155" data-mp="ne7eic482b1n">Sur les routes de France depuis 2012</p>
          <p className="mt-2 font-display leading-[0.8] text-signal" data-id="element-156" data-mp="scr20gygruw4">
            <span ref={ref} className="text-[34vw] lg:text-[18rem]" aria-label="Plus de 200" data-id="element-157" data-mp="saob7uphlxqc">
              {count}+
            </span>
          </p>
          <p className="mt-4 font-display text-4xl uppercase md:text-5xl" data-id="element-158" data-mp="3swad75ew04aw">dates et autant de foules debout.</p>
        </div>

        <div data-id="element-159" data-mp="aiuh01vfmx8t">
          <Reveal data-id="element-160" data-mp="algknqf7cslr">
            <p className="text-lg leading-relaxed text-paper/80 md:text-xl" data-id="element-161" data-mp="5k9cvrd27tf3">
              Créé en 2012 autour du chanteur-guitariste <span className="text-paper" data-id="element-162" data-mp="3dzjc8rpkekj6">Julien Bonnemain</span>,
              Téléphomme rejoue les grands titres de Téléphone avec la même urgence que le groupe d’origine. Pas
              de déguisement : du son, de la sueur et des refrains repris par toute la salle.
            </p>
          </Reveal>
          <dl className="mt-10 border-t border-paper/15" data-id="element-163" data-mp="3iyw821yez1xw">
            {facts.map((fact, i) => <Reveal key={fact.value} delay={i * 0.05} data-id="element-164" data-mp="1378f0hmittkd" data-mpi={i}>
                <div className="flex items-baseline justify-between gap-6 border-b border-paper/15 py-5" data-id="element-165" data-mp="139uju9i11uyw">
                  <dt className="text-paper/60" data-id="element-166" data-mp="169mmm8p5twuc">{fact.label}</dt>
                  <dd className="font-display text-3xl uppercase" data-id="element-167" data-mp="169316i0awqbk">{fact.value}</dd>
                </div>
              </Reveal>)}
          </dl>
        </div>
      </div>
    </section>;
}